import type {
  RegisterFormValues,
} from '~/schema/register-form-schema'
import {
  getRegisterFormSchema,
} from '~/schema/register-form-schema'

export { getRegisterFormSchema }
export type { RegisterFormValues }

export type PostRegisterRequest = RegisterFormValues

const DEFAULT_INITIAL_VALUES: RegisterFormValues = {
  email: '',
  password: '',
  userName: '',
}

export function getInitialDefaultValues({
  defaultInitialValues,
}: {
  defaultInitialValues?: Partial<RegisterFormValues>
}): Partial<RegisterFormValues> {
  return {
    ...DEFAULT_INITIAL_VALUES,
    ...defaultInitialValues,
  }
}
